import { render, staticRenderFns } from "./shuttle-box.vue?vue&type=template&id=22ae808f&scoped=true&"
import script from "./shuttle-box.vue?vue&type=script&lang=js&"
export * from "./shuttle-box.vue?vue&type=script&lang=js&"
import style0 from "./shuttle-box.vue?vue&type=style&index=0&id=22ae808f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae808f",
  null
  
)

export default component.exports